import { render, staticRenderFns } from "./RELDiarioBordo.vue?vue&type=template&id=57bcc0fe&"
import script from "./RELDiarioBordo.vue?vue&type=script&lang=js&"
export * from "./RELDiarioBordo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports